/**
 * @generated SignedSource<<1f747714be69cd8551a9cc52fc685da3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DownloadReportsPopupButton_surveys$data = ReadonlyArray<{
  readonly dataSheet: {
    readonly commentCount: number;
    readonly respondentCount: number;
    readonly responseCount: number;
    readonly responseRate: number;
  } | null | undefined;
  readonly resultsUnlocked: boolean;
  readonly surveyDate: string;
  readonly surveyNumber: number;
  readonly timeZone: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadPQiFeedbackButton_survey" | "DownloadPQiSummaryOrQualityReportButton_survey">;
  readonly " $fragmentType": "DownloadReportsPopupButton_surveys";
}>;
export type DownloadReportsPopupButton_surveys$key = ReadonlyArray<{
  readonly " $data"?: DownloadReportsPopupButton_surveys$data;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadReportsPopupButton_surveys">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DownloadReportsPopupButton_surveys",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsUnlocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DataSheet",
      "kind": "LinkedField",
      "name": "dataSheet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "respondentCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "responseRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "responseCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownloadPQiSummaryOrQualityReportButton_survey"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownloadPQiFeedbackButton_survey"
    }
  ],
  "type": "ProjectSurvey",
  "abstractKey": null
};

(node as any).hash = "bd2cbe3485c53f9add9b6a424bdb5507";

export default node;
